import range from 'lodash/range'
import React, { memo } from 'react'
import { useParams } from 'react-router-dom'

import { displayLocalizedTime, getTimeFromMinutes } from '@procsea/common/utils'
import { FormOnChange, MyOptionType, Select } from '@procsea/design-system'

import { LocaleParams } from 'src/types'

type Value = number | null

export interface TimeSelectorProps {
  'data-e2e'?: string
  disabled?: boolean
  errorMessage?: string
  fluid?: boolean
  helpText?: string
  label?: string
  name?: string
  onChange?: FormOnChange<Value>
  placeholder?: string
  value?: Value
}

const TimeSelector = ({
  'data-e2e': dataE2e = 'time-select',
  disabled,
  errorMessage,
  fluid,
  helpText,
  label,
  name,
  onChange,
  placeholder = gettext('Hour'),
  value,
}: TimeSelectorProps) => {
  const { locale } = useParams<LocaleParams>()
  const timeOptions: MyOptionType<number>[] = range(0, 96).map(count => {
    const minutes = 15 * count

    const time = displayLocalizedTime({ locale, time: getTimeFromMinutes(minutes) })

    return {
      value: minutes,
      label: time,
    }
  })

  return (
    <Select<Value, false>
      clearable
      data-e2e={dataE2e}
      disabled={disabled}
      errorMessage={errorMessage}
      fluid={fluid}
      helpText={helpText}
      label={label}
      name={name}
      minWidth={fluid ? undefined : '9.3rem'}
      onChange={onChange}
      options={timeOptions}
      placeholder={placeholder}
      value={value}
      width={fluid ? undefined : '9.3rem'}
    />
  )
}

export default memo(TimeSelector)
